module.exports = __webpack_public_path__ + "static/media/cake-1.2ddcc309.jpeg";